import React from "react";
import {useMutation, useSubscription} from "@apollo/client";
import {QUERY_PACKAGE} from "../registryComponentsGQL.js";
import {Box} from "grommet";
import {DataGrid} from "@mui/x-data-grid";
import {Button as ButtonMui} from "@mui/material";
import {DELETE_PACKAGE} from "./PackageGQL.js";

function Pacchetti(props){

    const [deletePackage]=useMutation(DELETE_PACKAGE);

    const { data, loading } = useSubscription(
      QUERY_PACKAGE,
    );

     const columnsPack = [
    { field: 'name', headerName: 'Nome', width: 350 },
    { field: 'number_of_entry', headerName: 'Numero di entrate', width: 130 },
    { field: 'price', headerName: 'Prezzo', width: 130 },
    { field: 'duration_in_days', headerName: 'Giorni di durata', width: 130 },
    { field: 'duration_in_month', headerName: 'Mesi di durata', width: 130 },
         { field: 'solar_package', headerName: 'Anno Solare', width: 130 },

    {
    field: 'Modifica',
    headerName: 'Modifica',
    width: 120,
    renderCell: (cellValues) => {
      return (

        <ButtonMui
          variant="contained"
         color="warning"
          onClick={(event) => {
            props?.setElementSel(cellValues.row)
          }}
        >
          Modifica
        </ButtonMui>
      );},
   },
   {
    field: 'Cancella',
    headerName: 'Cancella',
    width: 120,
    renderCell: (cellValues) => {
      return (

        <ButtonMui
          variant="contained"
          color="error"
          onClick={(event) => {
            let res=window.confirm("Sei sicuro di voler eliminare il pacchetto?");
            if(res){
              deletePackage({variables:{ id:cellValues.row.id}})
            }
          }}
        >
          Cancella
        </ButtonMui>
      );},
   }
  ];

    return (
      <Box overflow="auto"  height="100%" width="100%" alignSelf='center' style={{marginTop:'40px'}}>
        <div style={{ height: '72vh', width: '100%' }}>
          <DataGrid
            rows={data && data["clubmate_clubmatepackage_clubmatepackage"] || []}
            columns={columnsPack}
          />
        </div>
      </Box>
    )
}

export default Pacchetti;